
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: "Content Marketing Services in Goa - Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'Fuel your brand with authentic content so it connects with your audience. Content Marketing services in Goa includes blogs, web content, mailers and more.'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'content marketing in goa, content marketing strategy, content marketing agency in goa, content marketing services'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Content Marketing Services in Goa - Goa App'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Fuel your brand with authentic content so it connects with your audience. Content Marketing services in Goa includes blogs, web content, mailers and more.'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: 'Content Marketing Services in Goa - Goa App'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'Fuel your brand with authentic content so it connects with your audience. Content Marketing services in Goa includes blogs, web content, mailers and more.'
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: 'Content Marketing Services in Goa - Goa App'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/service-imgs/content-marketing.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/service-imgs/content-marketing.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/service-imgs/content-marketing.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Content Marketing Services in Goa - Goa App',
      description: 'Fuel your brand with authentic content so it connects with your audience. Content Marketing services in Goa includes blogs, web content, mailers and more.',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More Services on Goa App",
        "links": [
          {
            "sub_title": "Top Services",
            "interLinks": [
              {
                "name": "Digital Marketing Services in Goa",
                "url": "/digital-marketing"
              },
              {
                "name": "Website Development in Goa",
                "url": "/website-development"
              },
              {
                "name": "Search Engine Optimization in Goa",
                "url": "/search-engine-optimization"              
	   },
              {
                "name": "Advertising in Goa",
                "url": "/Advertising"
              },
              {
                "name": "Graphic Designing in Goa",
                "url": "/graphic-design"
              },
              {
                "name": "Social Media Marketing in Goa",
                "url": "/social-media-marketing"
              },
              {
                "name": "Content Marketing in Goa",
                "url": "/content-marketing"
              }

            ]
          },
        ]
      }
    };
  },


jsonld() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": "https://goa.app/content-marketing/#Service",
        "url": "https://goa.app/content-marketing",
        "name": "Content Marketing",
        "description": "Fuel your brand with authentic content so it connects with your audience. Content Marketing services in Goa & Mumbai includes blogs, web content, mailers and more.",
	"datePublished": "2024-06-14T00:00:00",
        "dateModified":  "2024-06-14T00:00:00",
        "image": "https://goa.app/img/service-imgs/content-marketing.webp",
        "serviceType": "Digital Marketing",
        "additionalType": "serviceOutput",
        "providerMobility": "provider",
        "provider": {
          "@type": "Corporation",
          "name": "Goa App",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Goa",
            "postalCode": "403505"
          },
          "telephone": "+91 9049248689"
        },
        "priceRange": "",
        "areaServed": {
          "@type": "City",
          "name": "Goa"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Content Marketing",
          "itemListElement": [
            {
              "@type": "Offer",
              "name": "Content Strategy"
            },
            {
              "@type": "Offer",
              "name": "Content Production"
            },
            {
              "@type": "Offer",
              "name": "Audience Analysis"
            },
            {
              "@type": "Offer",
              "name": "Content Tracking"
            },
            {
              "@type": "Offer",
              "name": "Web Content"
            },
            {
              "@type": "Offer",
              "name": "Onsite and Guest Blogs"
            },
            {
              "@type": "Offer",
              "name": "Ecommerce Content"
            },
            {
              "@type": "Offer",
              "name": "Emailers and Landing Pages"
            },
            {
              "@type": "Offer",
              "name": "Paid Ads and Social Media Content"
            }
          ]
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is Content Marketing?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Content marketing involves creating and distributing valuable, relevant content online to increase brand awareness, improve search rankings, and generate audience interest. This strategic approach aims to attract and retain a well-defined audience, ultimately driving them to take actions that benefit the company. Through content marketing, businesses build relationships, craft compelling stories, capture attention, and foster loyalty among their audience."
            }
          },
          {
            "@type": "Question",
            "name": "How Much Does Content Marketing Cost?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The cost of content marketing varies based on the type of content needed, your objectives, and the desired timeline. While content marketing can fit any budget, high-quality content that achieves significant results often comes at a higher cost. However, the investment in content marketing yields long-term benefits and a great return on investment (ROI). It's generally easier to maintain a strong position on search engines or build a loyal audience than to overtake a competitor, which might require more substantial initial investment. Contact Goa App, a leading content writing agency, to learn more about tailored pricing."
            }
          },
          {
            "@type": "Question",
            "name": "What Types of Businesses Can Benefit from Content Marketing?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Content marketing benefits any business aiming to reach and engage an audience, build trust, and foster loyalty. From large enterprises to small businesses across various industries—such as F&B, hospitality, retail, FMCG, BFSI, and tech—content marketing is advantageous. Both B2C and B2B brands can leverage content marketing, with techniques tailored to their specific goals but ultimately aiming to build strong relationships and drive engagement."
            }
          },
          {
            "@type": "Question",
            "name": "What Type of Content Will You Help Me Create for My Brand?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The right content mix varies by brand, and as a top content agency, Goa App tailors our offerings to meet your specific needs. We provide a variety of content types, including blog posts and articles for industry news and product usage, white papers, e-books, and case studies for original research, and infographics to visually explain complex concepts."
            }
          },
          {
            "@type": "Question",
            "name": "How Will Content Marketing Benefit My Business?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Content marketing guides people to buy from you with confidence by differentiating your brand from competitors. A great content marketing agency uses content to build meaningful relationships, earn trust, and keep your audience engaged, leading to increased sales and customer loyalty. Effective content marketing allows you to craft your brand story, showcase your unique offerings, grow your audience, and achieve a steady ROI over time."
            }
          },
          {
            "@type": "Question",
            "name": "My Brand is B2B, Why Do I Need Content Marketing?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "B2B buyers are human, just like B2C consumers, and they value creativity, storytelling, and long-term brand relationships. B2B brands often struggle to stand out with only rational product messaging. Content marketing helps B2B brands differentiate by forming long-lasting relationships, engaging in digital storytelling, and protecting brand reputation. This approach is essential for long-term success and maintaining a competitive edge."
            }
          },
          {
            "@type": "Question",
            "name": "Can I Generate Leads for My Business Through Content Marketing?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "With the right strategy, content marketing can generate a steady stream of new leads. High-value content like blog posts, articles, and videos attract and engage potential customers. Evergreen content continues to attract leads over time, while white papers, case studies, and e-books establish your brand as a market leader. Goa App helps you grow your mailing list, manage leads using sales funnels, and convert potential customers into loyal buyers."
            }
          }
        ]
      }
    ]
  };
},

  mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },

    getSpace(key) {
      return key.replace(/([A-Z])/g, " $1")
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
